import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Wrapper = styled.div`
	background-color: ${colors.grey1};
	height: 80%;
	overflow-y: scroll;
`;
